// Notification sounds, made on the spot (no files): the Hub and the Mac app sound the same.
// Chosen in mockups/neo-comms6.html; each person picks theirs in the profile card.

let ctx: AudioContext | null = null;
let VOL = 0.5;
const ac = () => (ctx ??= new AudioContext());

function tone(f: number, at: number, dur: number, { type = "sine" as OscillatorType, vol = 0.14, glide = 0, attack = 0.008 } = {}) {
  const c = ac(), t = c.currentTime + at, o = c.createOscillator(), g = c.createGain();
  o.type = type; o.frequency.setValueAtTime(f, t); if (glide) o.frequency.exponentialRampToValueAtTime(f * glide, t + dur);
  g.gain.setValueAtTime(0, t); g.gain.linearRampToValueAtTime(vol * VOL, t + attack); g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
  o.connect(g).connect(c.destination); o.start(t); o.stop(t + dur + 0.05);
}
function noise(at: number, dur: number, vol = 0.08, hp = 2000) {
  const c = ac(), t = c.currentTime + at, b = c.createBuffer(1, Math.floor(c.sampleRate * dur), c.sampleRate), d = b.getChannelData(0);
  for (let i = 0; i < d.length; i++) d[i] = (Math.random() * 2 - 1) * (1 - i / d.length);
  const s = c.createBufferSource(), f = c.createBiquadFilter(), g = c.createGain();
  f.type = "highpass"; f.frequency.value = hp; g.gain.value = vol * VOL; s.buffer = b; s.connect(f).connect(g).connect(c.destination); s.start(t);
}

export const SOUNDS: [string, string, () => void][] = [
  ["twotone", "Two-tone", () => { tone(988, 0, 0.12, { type: "triangle", vol: 0.16 }); tone(1480, 0.1, 0.18, { type: "triangle", vol: 0.16 }); }],
  ["knock", "Knock", () => { tone(880, 0, 0.22); tone(1320, 0.09, 0.22); }],
  ["ding", "Ding", () => { tone(1568, 0, 0.9, { vol: 0.12 }); tone(3136, 0, 0.5, { vol: 0.03 }); }],
  ["pop", "Pop", () => tone(600, 0, 0.09, { glide: 1.8, vol: 0.2 })],
  ["chime", "Chime", () => { tone(1047, 0, 0.5, { vol: 0.09 }); tone(1319, 0.08, 0.5, { vol: 0.09 }); tone(1568, 0.16, 0.7, { vol: 0.09 }); }],
  ["marimba", "Marimba", () => { tone(659, 0, 0.35, { type: "triangle", vol: 0.2 }); tone(988, 0.11, 0.4, { type: "triangle", vol: 0.18 }); }],
  ["bubble", "Bubble", () => { tone(400, 0, 0.12, { glide: 2.4, vol: 0.18 }); tone(700, 0.1, 0.1, { glide: 1.6, vol: 0.12 }); }],
  ["tap", "Tap", () => { noise(0, 0.04, 0.12, 3000); tone(2200, 0, 0.05, { vol: 0.05 }); }],
  ["bell", "Soft bell", () => { tone(784, 0, 1.4, { vol: 0.08, attack: 0.02 }); tone(1568, 0, 0.9, { vol: 0.03 }); tone(2352, 0, 0.5, { vol: 0.015 }); }],
  ["wood", "Woodblock", () => { tone(1200, 0, 0.06, { type: "square", vol: 0.05 }); noise(0, 0.03, 0.06, 1500); }],
  ["swoosh", "Swoosh", () => { noise(0, 0.35, 0.05, 900); tone(500, 0, 0.3, { glide: 3, vol: 0.04 }); }],
  ["none", "No sound", () => {}],
];

export function playSound(name: string, volume: number) {
  try { VOL = volume; (SOUNDS.find((s) => s[0] === name) ?? SOUNDS[0])[2](); } catch {}
}
